import {Component, Input, OnInit} from '@angular/core';
import {XROUTES} from 'src/app/shared/config';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-layout-main-2025',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.styl']
})
export class LayoutMain2025Component implements OnInit {

  @Input() navi = 0;

  S_ROOT_URL = environment.S_ROOT_URL;

  navs = [
    XROUTES[2025].index,
    XROUTES[2025].onlineexhibition,
    XROUTES[2025].onlinemap,
    XROUTES[2025].ychat,
    XROUTES[2025].yshop,
    XROUTES[2025].lookguide,
    XROUTES[2025].news,
    XROUTES[2025].report,
    XROUTES[2025].reservation,
    XROUTES[2025].previous
  ];

  footernavs = [
    [XROUTES[2025].onlineexhibition, XROUTES[2025].yshop, XROUTES[2025].report],
    [XROUTES[2025].onlinemap, XROUTES[2025].lookguide, XROUTES[2025].reservation],
    [XROUTES[2025].ychat, XROUTES[2025].news, XROUTES[2025].previous],
  ];

  email = 'shjiaobohui@163.com';

  constructor() {
  }

  ngOnInit() {

  }

}
